import { Inject } from '@odinjs/odin';

import { PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, ModalConfirmarUsuarioAliases, RootRoutes } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.MODAL_CONFIRMAR_USUARIO })
export default class ModalConfirmarUsuarioController extends BaseController {

  @Inject(ModalConfirmarUsuarioAliases.PANEL_AVISO)
  private panelAviso: PanelAPI;
  @Inject(ModalConfirmarUsuarioAliases.PANEL_AVISO_SUCESSO)
  private panelAvisoSucesso: PanelAPI;
  @Inject(ModalConfirmarUsuarioAliases.PANEL_AVISO_FALHA)
  private panelAvisoFalha: PanelAPI;

  @OnMount(ModalConfirmarUsuarioAliases.PANEL_LOADER)
  onMount({ target }: MountEvent): void {
    const api = target as PanelAPI;
    const { hash } = this.historyService.getCurrentRouteParams();

    HttpService.post(Endpoints.POST.CONFIRMACAO_NOVO_USUARIO, { hash })
      .then(() => {
        this.panelAviso.setVisible(true);
        this.panelAvisoSucesso.setVisible(true);
      })
      .catch(() => {
        this.panelAviso.setVisible(true);
        this.panelAvisoFalha.setVisible(true);
      })
      .finally(() => api.setVisible(false));
  }

  @OnClick(ModalConfirmarUsuarioAliases.BUTTON_FECHAR)
  onClick = (): void => this.historyService.push(RootRoutes.ROUTE_LOGIN);
}
